import { render } from "./editorComponent.vue?vue&type=template&id=63738da5"
import script from "./editorComponent.vue?vue&type=script&lang=js"
export * from "./editorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__